export default __webpack_public_path__ + "static/media/wom.5e979bf9.mp3";